import { render, staticRenderFns } from "./CreatePartners.vue?vue&type=template&id=ca383c2e&"
import script from "./CreatePartners.vue?vue&type=script&lang=js&"
export * from "./CreatePartners.vue?vue&type=script&lang=js&"
import style0 from "./CreatePartners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports